import { callUIAPI } from './apiUtils';
import * as apiConstants from './apiUtilsConstants';
import * as dbConstants from '../dao/dbConstants';
import { pollJob, startAndPollJob } from './jobPollingUtils';

export const fetchLinksMetadata = async (urls) => {
  const response = await callUIAPI('links/metadata', { urls }, apiConstants.METHOD_POST, true);
  return response.data?.list || [];
};



export const deleteAssetLink = async (assetId, linkId) => {
  console.log('linkApiUtils.deleteAssetLink - assetId:', assetId, ', linkId:', linkId);
  return callUIAPI(apiConstants.entityAPIRoutes[dbConstants.ENTITY_NAME_ASSET] + `/${assetId}/links/${linkId}`, null, apiConstants.METHOD_DELETE, true)
    .then(response => {
      console.log('linkApiUtils.deleteAssetLink - response:', response);
      return response.data;
    });
};

export const createMultipleInternalLinks = async (assetId, urls, onProgress) => {
  console.log('linkApiUtils.createMultipleInternalLinks - assetId:', assetId, ', urlsCount:', urls.length);
  return startAndPollJob(
    apiConstants.entityAPIRoutes[dbConstants.ENTITY_NAME_ASSET] + `/${assetId}/links/internal/bulk/async`,
    { urls },
    'assets/links/import-status',
    onProgress,
    { intervalMs: 2000 }
  ).then(response => response.data);
};


export const cancelImportJob = async (jobId) => {
  console.log('linkApiUtils.cancelImportJob - jobId:', jobId);
  return callUIAPI(`assets/links/import-status/${jobId}`, null, apiConstants.METHOD_DELETE, true)
    .then(response => {
      console.log('linkApiUtils.cancelImportJob - response:', response);
      return response.data;
    });
};

export const importInternalLinksFromWebsite = async (assetId, url, onJobCreated, onProgress) => {
  console.log('linkApiUtils.importInternalLinksFromWebsite - assetId:', assetId, ', url:', url);
  const response = await callUIAPI(
    apiConstants.entityAPIRoutes[dbConstants.ENTITY_NAME_ASSET] + `/${assetId}/links/internal/import`,
    { url },
    apiConstants.METHOD_POST,
    true
  );
  console.log('linkApiUtils.importInternalLinksFromWebsite - initiated job:', response.data);
  const { jobId } = response.data;

  if (onJobCreated && typeof onJobCreated === 'function') {
    onJobCreated(jobId);
  }

  return pollJob(`assets/links/import-status/${jobId}`, onProgress, { intervalMs: 2000 })
    .then(res => res.data);
};